var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineHeartTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.45 20.05c-.52-.84-.8-1.84-.8-2.85 0-3.06 2.49-5.55 5.55-5.55 3.06 0 5.55 2.49 5.55 5.55 0 1.02-.28 2.01-.81 2.87-.98 1.65-2.8 2.68-4.74 2.68a5.54 5.54 0 0 1-4.75-2.7zm.7-2.85c0 .74.2 1.46.58 2.08a3.994 3.994 0 0 0 3.47 1.97c1.44 0 2.73-.73 3.46-1.96.39-.63.59-1.35.59-2.09 0-2.23-1.82-4.05-4.05-4.05-2.23 0-4.05 1.82-4.05 4.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.98 18.91-1.18-1.18a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.67.67 2.03-1.88c.31-.28.78-.26 1.06.04s.26.78-.04 1.06l-2.56 2.36c-.14.15-.33.21-.51.21-.19 0-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.13 21.52c-2.56-.87-9.88-5.11-9.88-12.83 0-3.5 2.83-6.34 6.31-6.34 1.66 0 3.27.67 4.44 1.84a6.308 6.308 0 0 1 4.44-1.84c3.48 0 6.31 2.84 6.31 6.34 0 1.95-.47 3.82-1.4 5.57a.74.74 0 0 1-.56.39.758.758 0 0 1-.65-.23 4.028 4.028 0 0 0-2.94-1.28c-2.23 0-4.05 1.82-4.05 4.05 0 .99.37 1.95 1.04 2.7.16.18.22.42.17.65-.05.23-.21.43-.42.53-.4.18-.76.33-1.09.44-.24.1-.54.14-.85.14-.31 0-.62-.04-.87-.13zM2.75 8.69c0 6.84 6.57 10.62 8.87 11.41.19.07.57.06.75 0l.09-.03c-.53-.86-.81-1.85-.81-2.87 0-3.06 2.49-5.55 5.55-5.55 1.16 0 2.3.37 3.24 1.05.54-1.28.81-2.62.81-4.01 0-2.67-2.16-4.84-4.81-4.84-1.5 0-2.94.72-3.84 1.93-.28.38-.92.38-1.2 0a4.812 4.812 0 0 0-3.84-1.93c-2.65 0-4.81 2.17-4.81 4.84z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHeartTick);
export default __webpack_public_path__ + "static/media/vuesax-outline-heart-tick.a81d368c8057160fde87c32d71d1637f.svg";
export { ForwardRef as ReactComponent };